var React = require("react");
const PropTypes = require('prop-types');

// the styling and DOM is just a mock at the moment and will be replaced
// with the proper design

var Step = function(props) {
	const classNames = "step";

	var icon = null;
	if (props.is_finished) {
		icon = (<i className="fa fa-check" aria-hidden="true"></i>);
	}

	if (props.is_finished && props.is_skipped) {
		icon = (<i className="fa fa-level-down" aria-hidden="true"></i>);
	}

	if (props.is_finished && props.is_failed) {
		icon = (<i className="fa fa-times" aria-hidden="true"></i>);
	}

	return (
		<li
			className={classNames}
			role="presentation"
		>
			{props.id + 1}. {props.title} {icon}
		</li>
	);
};

Step.propTypes = {
	id: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired
};

var StepMenu = function(props) {
	var list = Object.keys(props.steps).map(function(key, index) {
		return (
			<Step
				is_finished={props.steps[key].is_finished}
				is_skipped={props.steps[key].is_skipped}
				is_failed={props.steps[key].is_failed}
				key={index}
				title={props.steps[key].title}
				id={index}
				is_loading={props.steps[key].is_loading}
			/>
		);
	});

	return (
		<ul className="step-menu nav nav-pills nav-stacked">
			{list}
		</ul>
	);
};

StepMenu.propTypes = {
	steps: PropTypes.arrayOf(PropTypes.shape({
		title: PropTypes.string.isRequired
	}).isRequired).isRequired
};

module.exports = StepMenu;
